import React from 'react'
import { Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'

import './css/HowItWorks.css'
import InviteForm from './InviteForm'
import HowItWorksText from './text/how-text'

export default class HowItWorks extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSmallScreen: false
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    let isSmallScreen = !!(window.innerWidth < 800)
    this.setState({
      isSmallScreen
    })
  }

  renderInviteButton = () => (
    <div className="orange-button how-button">
      <Link to="/invite">GET YOUR INVITATION</Link>
    </div>
  )

  renderSmallText = text => (
    <div
      key={text}  
      className="line small-text">{text}</div>
  )

  renderHowItWorksContainer = () => (
    <div className="how-container">
      <div className="left">
        <div className="section">
          <div className="about-header">HOW IT WORKS</div>
          <div className="small-text">{HowItWorksText[0]}</div>
        </div>
        <div className="section main-section">
          <div className="blue-subheader">If you are</div>
          {HowItWorksText.slice(1, 6).map(this.renderSmallText)}
        </div>
        <div className="section">
          <div className="blue-subheader">...We’ll help you navigate the next steps.</div>
          <div className="graph-header">{HowItWorksText[6]}</div>
          <div className="graph-subtext">{HowItWorksText[7]}</div>
          <div className="median-graph" />
          {this.state.isSmallScreen ? this.renderInviteButton() : null}
          <div className="small-text">{HowItWorksText[8]}</div>
        </div>
        <div className="section main-section">
          <div className="about-subheader">HOW TO GET STARTED</div>
          <div className="line small-text">
            <a href="">{HowItWorksText[9]}</a>
          </div>
          {HowItWorksText.slice(10, 14).map(this.renderSmallText)}
        </div>
        <div className="section">
          <div className="about-subheader">{HowItWorksText[14]}</div>
        </div>
        <div className="section main-section">
          <div className="about-subheader">THE TYPICAL STUDENT</div>
          {HowItWorksText.slice(15, 21).map(this.renderSmallText)}
        </div>
        <div className="section unemployment">
          <div className="about-subheader">ADDITIONAL STATS FOR STUDENTS</div>
          <div className="graph-header">{HowItWorksText[21]}</div>
          <div className="graph-subtext">{HowItWorksText[7]}</div>
          <div className="unemployment-graph" />
        </div>
        <div className="section">
          {this.state.isSmallScreen ? this.renderSmallBottom() : this.renderLargeBottom()}
          {this.renderInviteButton()}
        </div>
      </div>
      <div className="right">
        <div className="blue-header">DON’T PURSUE EDUCATION TO LEARN AT RANDOM.</div>
        <div className="small-section small-text">{HowItWorksText[23]}</div>
        <div className="small-section small-text">{HowItWorksText[24]}</div>
        <InviteForm />
      </div>
    </div>
  )

  renderSmallBottom = () => (
    <div className="section">
      <div className="blue-header">DON’T PURSUE EDUCATION TO LEARN AT RANDOM.</div>
      <div className="small-section small-text">{HowItWorksText[23]}</div>
      <div className="small-section small-text">{HowItWorksText[24]}</div>
    </div>
  )

  renderLargeBottom = () => (
    <div className="about-header about-subheader">{HowItWorksText[22]}</div>
  )

  render() {
    return (
      <CSSTransitionGroup
        transitionName="slide"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionLeaveTimeout={500}
        transitionEnter={false}
        transitionLeave={true}>
        {this.renderHowItWorksContainer()}
      </CSSTransitionGroup>
    )
  }
}



// WEBPACK FOOTER //
// src/HowItWorks.js